import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UPLOAD_URL } from "../../../utils/constants";
import Navbar from "./Navbar";
import { getRequest } from "../../../helpers/api.helper";

const SuccessStoriesPage = () => {
  const { id, name } = useParams();
  const [successStories, setSuccessStories] = useState([]);
  const [navbarLogo, setNavbarLogo] = useState("");
  useEffect(() => {
    const fetchBureauDetails = async () => {
      try {
        const response = await getRequest(`/bureau/website/${id}`);
        if (response.success) {
          const { successStories, profile } = response.data;
          setSuccessStories(successStories);
          setNavbarLogo(profile.navbarLogo);
        }
      } catch (error) {
        console.error("Error fetching bureau details:", error);
      }
    };

    fetchBureauDetails();
  }, [id]);
  return (
    <div className="pt-28 sm:pt-36 pb-20 bg-gradient-to-b from-rose-50 via-white to-pink-50 min-h-screen">
      <Navbar bureauName={name} navbarLogo={navbarLogo} />
      <div className="max-w-6xl mx-auto px-4">
        {/* Heading */}
        <div className="text-center sm:mb-14 mb-8">
          <h2 className="text-4xl font-serif font-semibold text-rose-900">
            Success Stories
          </h2>
          <p className="text-rose-500 mt-2">
            Real couples who found their perfect match at {name}
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {successStories?.map((story: any) => (
            <div
              key={story.id}
              className="bg-white border border-rose-100 rounded-3xl shadow-lg hover:shadow-xl transition overflow-hidden"
            >
              <img
                src={`${UPLOAD_URL}/bureaus/stories/${story.image_path}`}
                alt={story.title}
                className="h-60 w-full object-cover"
              />

              <div className="p-6">
                <h4 className="text-lg font-semibold mb-2 text-rose-900">
                  {story.title}
                </h4>

                <p className="text-sm text-gray-500 mb-2">
                  Married:{" "}
                  {new Date(story.marriage_date).toLocaleDateString("en-IN")}
                </p>

                <p className="text-gray-700 text-sm leading-relaxed">
                  {story.description}
                </p>

                <p className="text-xs text-rose-400 mt-4">
                  Posted on:{" "}
                  {new Date(story.createdAt).toLocaleDateString("en-IN")}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessStoriesPage;
